import { grouped } from "./grades";
// Older than this, the import is the current step again: a fresh one finds more.
const GALLERY_IMPORT_STALE_AFTER_MS = 5 * 60 * 1000;
// The optional sync, skipped on a phone's one-step-at-a-time view.
export const GALLERY_SYNC_SKIPPED_KEY = "easysbc.gallerySyncSkipped";
/** Time since the last Club Import, in ms; 0 without one. */
export const galleryImportAge = (lastImportedAt, now) => (lastImportedAt ? now - lastImportedAt : 0);
/**
 * The collected-players sync as the steps read it. Done when fresh (the
 * backend decides) or used up for this content cycle.
 */
export const describeCollectedSync = (sync, running, now) => {
    const fresh = !!sync && !sync.collectedStale && !running;
    // One completed sync per content cycle: until the next release it only reads.
    const locked = !!sync?.nextSyncAt && Date.parse(sync.nextSyncAt) > now;
    return {
        done: fresh || (locked && !running),
        /** When the next sync opens; set while this cycle's is used up. */
        nextSyncAt: locked && sync?.nextSyncAt ? new Date(sync.nextSyncAt) : undefined,
        collected: sync && {
            count: grouped.format(sync.collectedCount),
            total: grouped.format(sync.total),
        },
    };
};
/**
 * Each step's state, and the one a phone shows: the first not done (a
 * skipped sync counts as done), else the last.
 */
export const galleryStepStates = ({ withImport = true, clubImported, importAgeMs, syncDone, syncRunning, syncSkipped, built, buildDone, }) => {
    const importStale = clubImported && importAgeMs >= GALLERY_IMPORT_STALE_AFTER_MS;
    const states = {
        import: clubImported && !importStale ? "done" : "current",
        sync: !clubImported
            ? "locked"
            : syncDone
                ? "done"
                : built || syncRunning
                    ? "current"
                    : "optional",
        build: !clubImported ? "locked" : buildDone ? "done" : "current",
    };
    const keys = [
        ...(withImport ? ["import"] : []),
        "sync",
        "build",
    ];
    const pending = keys.findIndex((key) => states[key] !== "done" &&
        !(key === "sync" && syncSkipped && !syncRunning));
    const active = pending === -1 ? keys.length - 1 : pending;
    return {
        keys,
        states,
        importStale,
        /** The step a phone opens on. */
        active,
    };
};
//# sourceMappingURL=steps.js.map